<template>
  <div>

    <h5>Shipping Address</h5>

   <!-- <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-2">
        <vs-input class="w-full" label-placeholder="First Name" v-model="buyerFirstName" />
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
        <vs-input class="w-full" label-placeholder="Last Name" v-model="buyerLastName" />
        </div>
    </div>
    <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-2">
        <vs-input class="w-full" label-placeholder="Email Address" v-model="buyerEmail" />
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
        <vs-input class="w-full" label-placeholder="Phone Number" v-model="buyerPhone" />
        </div>
    </div>-->
    <div class="vx-row">
        <!--<div class="vx-col w-full mb-2">
        <vs-input class="w-full" label-placeholder="Company Name" v-model="buyerCompany" />
        </div>-->
        <div class="vx-col w-full mb-2">
        <vs-input class="w-full" label-placeholder="Address Line" name="address" v-model="buyerAddress" v-validate="'required'" />
         <span class="text-danger text-sm" v-show="errors.has('address')">{{ errors.first('address') }}</span>
        </div>
        <!--<div class="vx-col w-full mb-2">
        <vs-input class="w-full" label-placeholder="Address Line 2" v-model="buyerAddressTwo" />
        </div>-->
    </div>
    <div class="vx-row">
         <div class="vx-col md:w-1/2 w-full mb-2">
        <vs-input class="w-full" name="postcode" label-placeholder="Postcode" v-model="buyerPostcode" v-on:change="getshipping()" v-validate="'required'"/>
         <span class="text-danger text-sm" v-show="errors.has('postcode')">{{ errors.first('postcode') }}</span>
        </div>
         <div class="vx-col md:w-1/2 w-full mb-2">
        <v-select :options="cityOptions" :clearable="false" v-model="buyerCity" />
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
        <vs-input class="w-full" label-placeholder="Country" v-model="buyerCountry"  readonly/>
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
         <vs-input class="w-full" label-placeholder="State" v-model="buyerState"  readonly/>
         <!--<v-select :options="stateOptions"  item-text="label" item-value="id" :clearable="false" v-model="buyerState" @input="stateChanged" v-validate="'required'"/>-->
        </div>
       
    </div>
    <!--<div class="vx-row">
      <div class="vx-col w-full ml-auto">
        <vs-checkbox class="inline-flex" v-model="billingRefer" >Use different address as billing address</vs-checkbox>
      </div>
    </div>-->

    <!-- billing address -->
    <template v-if="billingRefer">
    <vs-divider/>
    <h5>Billing Address</h5>

    <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-2">
        <vs-input class="w-full" label-placeholder="First Name" v-model="billingFirstName" />
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
        <vs-input class="w-full" label-placeholder="Last Name" v-model="billingLastName" />
        </div>
    </div>
    <div class="vx-row">
        <div class="vx-col w-full mb-2">
        <vs-input class="w-full" label-placeholder="Address Line 1" v-model="billingAddressOne" />
        </div>
        <div class="vx-col w-full mb-2">
        <vs-input class="w-full" label-placeholder="Address Line 2" v-model="billingAddressTwo" />
        </div>
    </div>
    <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-2">
        <vs-input class="w-full" label-placeholder="Country" v-model="billingCountry" />
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
        <vs-input class="w-full" label-placeholder="State" v-model="billingState" />
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
        <vs-input class="w-full" label-placeholder="Postcode" v-model="billingPostcode" />
        </div>
        <div class="vx-col md:w-1/2 w-full mb-2">
        <vs-input class="w-full" label-placeholder="City" v-model="billingCity" />
        </div>
    </div>
    </template>
    <!-- billing address -->

  <vs-divider></vs-divider>
     <h5>Shipping Method</h5>
    <div class="vx-row">
         <div class="vx-col w-full mb-2">
            <v-select :options="shippingOptions" :clearable="false" v-model="shippingMethod" />
        </div>
    </div>

   <vs-divider/>

                <div>
                  <div class="centerx mt-4">
                    <vs-button type="flat" icon-pack="feather" icon="icon-arrow-left" @click.stop="backToOrder()">Return to Edit Order</vs-button>
                    <vs-button type="filled" icon-pack="feather" icon="icon-arrow-right" icon-after class="w-full mt-2 shadow-md" @click.stop="confirmDeliveryInfo()">Continue</vs-button>
                  </div>
                </div>
  </div>
</template>
<script src="https://js.stripe.com/v3/"></script>

<script>
var stripe = Stripe('pk_test_51I3nOXCfnIZtmCT7cCHzz8yESXxNu7DicwSqlJS8F9GZiVk2WSbnn7dMIDCcjzBhN5waunDRourDnJmZGURj6p9W00Tio2wD9C');

import vSelect from 'vue-select';
import axios from '@/axios';
import router from '@/router';

const dialogs = {
  invalidCoverage: (error) => {
    return {
      color: "danger", 
      title: "Delivery Postcode Not Covered",
      text: "Oops, looks like your delivery postcode is not covered. Please contact the sales person for more assistance.",
      accept: () => {
        //router.push('/forms');
      },
      close: () => {
        //router.push('/forms');
      }
    }
  }, 
  incompleteInformation: (error) => {
    return {
      color: "danger", 
      title: "Delivery Information Incomplete",
      text: "Oops, Looks like some information missing please complete the delivery information and choose your shipping",
      accept: () => {
        //router.push('/forms');
      },
      close: () => {
        //router.push('/forms');
      }
    }
  },
}

export default {
  components: {
      vSelect
  },
  data(){
    return {
      buyerFirstName: "",
      buyerLastName: "",
      buyerEmail: "",
      buyerphone: "",
      buyerCompany: "",
      buyerAddress: "",
      buyerAddressTwo: "",
      buyerCountry: "Malaysia",
      buyerState: "",
      buyerPostcode: "",
      buyerCity: { label: 'Please key in postcode first', value: '' },
      billingFirstName: "",
      billingLastName: "",
      billingAddressOne: "",
      billingAddressTwo: "",
      billingCountry: "",
      billingState: "",
      billingPostcode: "",
      billingCity: "",
      billingRefer: false,
      shippingMethod: { label: 'Choose your shipping method', value: '' },
      shippingOptions: [
      ],
      stateCode:"",
      stateOptions:[
      { id: "PLS", label: "Perlis" },
      { id: "KDH", label: "Kedah" },
      { id: "PNG", label: "Pulau Pinang" },
      { id: "KTN", label: "Kelantan" },
      {id:"TRG", label:"Terengganu"},
      {id:"PHG", label:"Pahang"},
      {id:"PRK", label:"Perak"},
      {id:"SGR", label:"Selangor"},
      {id:"KUL", label:"Kuala Lumpur"},
      {id:"PJY", label:"PutraJaya"},
      {id:"NSN", label:"Negeri Sembilan"},
      {id:"MLK", label:"Melaka"},
      {id:"JHR", label:"Johor"},
      {id:"LBN", label:"Labuan"},
      {id:"SBH", label:"Sabah"},
      {id:"SRW", label:"Sarawak"}
      ],
      cityOptions:[]
    }
  },
  created() {
    //this.getshipping();
  },
  methods : {
    async getshipping(){

      if(this.buyerPostcode.length==5){
      //Need to be using postcode
        let order_id = this.$route.params.orderid;
                try {
                    let res = await axios.get('/order/shipping/'+order_id+'/'+this.buyerPostcode);

                      //Reset compulsory incase they got choose before
                      this.shippingMethod.value="";
                      this.shippingMethod.label="Choose your shipping method";

                      this.shippingOptions=res.data.data.shipping;

                      this.buyerCity=res.data.data.details[0].area;

                        this.cityOptions=[];
                       Object.entries(res.data.data.details).forEach(([key, val]) => {
                         this.cityOptions.push(val.area);
                       });
                      

                this.stateCode=res.data.data.details[0].state_code;

                Object.entries(this.stateOptions).forEach(([key, val]) => {
                  //console.log(key);
                  
                    if(val.id==res.data.data.details[0].state_code){
                      this.buyerState=val.label;
                   
                    }
                });
                      //this.buyerState=res.data.data.details[0].state_code;
                      
                    //return res.data.data;
                }
                catch (e) {
                    this.$vs.dialog(dialogs.invalidCoverage());
                }
      }
      else
      {
         this.buyerCity="";
         this.cityOptions=[];
         this.buyerState="";
         this.shippingMethod.value="";
         this.shippingMethod.label="Choose your shipping method";
        
      }
    },
    async stateChanged(){
      this.buyerPostcode='';
      this.buyerCity="{ label: 'Please key in postcode first', value: '' }";
    },
    async backToOrder() {
      //I put this method here so that for existing order can be used to update rather than insert
         router.push(`/order/${this.$route.params.orderid}`) 
    },
    async confirmDeliveryInfo()
    {
      this.$validator.validateAll().then(result => {    
          if(this.shippingMethod.value==="" || this.buyerAddress==="" || this.buyerPostcode==="")
          {
            this.$vs.dialog(dialogs.incompleteInformation());
          }
          else
          {
              this.updateDeliveryInfo();
          }

           });  
    },
    async updateDeliveryInfo()
    {
       var params={
        'order_id': this.$route.params.orderid,
        'address':  this.buyerAddress,
        'postcode': this.buyerPostcode,
        'area':this.buyerCity,
        'state_code':this.stateCode,
        'country_code':'MY',
        'shipping':this.shippingMethod.id,
      };

      console.log(params);

      try {
        let res = await axios.patch('/order/secondstep', params);
        router.push(`/summary/${res.data.data.id}`);
      }catch (e) {
        throw e;
      }

       
    }

  }
}
</script>